var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-user",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picto_my_kaercher_no_K_oth_3_RGB",
    transform: "translate(6.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.81490015,10.0693642 C9.55529954,10.297275 9.27572965,10.4954583 8.97619048,10.6639141 C10.8133641,11.5656482 12.0714286,13.4483898 12.0714286,15.6184971 L12.0714286,21.0883567 L0.938556068,21.0883567 L0.938556068,15.6184971 C0.938556068,13.4087531 2.24654378,11.5061932 4.13364055,10.6143683 C3.84408602,10.4360033 3.56451613,10.23782 3.30491551,10 C1.33794163,11.1098266 0,13.2105698 0,15.6085879 L0,22 L13,22 L13,15.6085879 C13,13.2601156 11.7219662,11.1990091 9.81490015,10.0693642 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10 C4.79376499,10 3,7.76008493 3,5 C3,2.23991507 4.79376499,0 7,0 C9.20623501,0 11,2.23991507 11,5 C10.9904077,7.74946921 9.19664269,10 7,10 Z M7,0.976645435 C5.29256595,0.976645435 3.89208633,2.78131635 3.89208633,4.98938429 C3.89208633,7.20806794 5.28297362,9.00212314 7,9.00212314 C8.70743405,9.00212314 10.1079137,7.19745223 10.1079137,4.98938429 C10.0983213,2.78131635 8.70743405,0.976645435 7,0.976645435 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.01162ec81bd443e4a8c11edcd504e695.svg";
export { ForwardRef as ReactComponent };